<template>
	<div v-title title="发票抬头" class="fp-list-page">
		<div class="no-more" v-if="!dataList || !dataList.length">
			<img class="img" src="@/assets/images/coupon/bg_no_more.png" alt="" />
			<span class="tips">抱歉，暂未添加发票抬头呢～</span>
		</div>
		<div class="tt-list" v-else>
			<div class="tt-list-item" v-for="item in dataList" :key="item.id">
				<div class="tt-name-tag">
					<span class="tt-name">{{ item.payerName }}</span>
					<span class="tt-tag">
						{{ item.payerType == '1' ? '个人' : '企业' }}
					</span>
				</div>
				<span class="tt-cont" v-if="item.payerType == '1'">{{ item.receiverEmail }}</span>
				<span class="tt-cont" v-else>税号： {{ item.payerRegisterNo }}</span>
				<div class="tt-btn" @click="useFapiao(item.id)">使用</div>
				<div class="tt-line"></div>
				<div class="tt-d" @click="changeDefault(item)">
					<img v-if="item.isDefault == '1'" class="tt-d-icon" src="@/assets/images/product/icon_default.png" alt="" />
					<img v-else class="tt-d-icon" src="@/assets/images/product/icon_default_no.png" alt="" />
					<span class="tt-d-text">{{ item.isDefault == '1' ? '已' : '' }}设为{{ item.payerType == '1' ? '个人' : ''
					}}默认</span>
				</div>
				<img class="tt-icon-edit" @click="edittaitou(item.id)" src="@/assets/images/product/icon_edit.png" />
				<img class="tt-icon-del" @click="deletetaitou(item.id)" src="@/assets/images/product/icon_del.png" />
			</div>
		</div>
		<div class="btn-box" @click="addFapiao">
			<div class="btn">
				新增发票抬头
			</div>
		</div>
		<MyDialog :dialogForm="dialogForm" />

		<div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/orderFapiaoList"></div>
	</div>
</template>

<script>

import MyDialog from '@/components/MyDialog.vue'
export default {
	name: "Order",
	components: {
		MyDialog,
	},
	data() {
		return {
			dialogForm: {
				show: false,
				title: '',
				contentText: '',
				contentTips: '',
				// btnCancelText: '取 消',
				btnConfirmText: '',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
				}
			},
			radio: '',
			searchForm: {
				orderId: ''
			},
			submitForm: {
				orderId: '',
				receiveAddressId: '',
			},
			detail: {},
			dataList: []
		};
	},
	created() {
		this.searchForm.orderId = this.$route.query.orderId
		this.getList()


		let self = this
		this.$nextTick(() => {
			self.$refs['maidian'].click()
		})
	},
	methods: {
		submit() {

		},
		onClickLeft() {
			this.$router.push({
				path: '/orderDetail',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status
				}
			})

		},
		goToDetail() {

		},
		addFapiao() {
			this.$router.push({
				path: '/orderApplyFapiao',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status
				}
			})
		},
		getList() {
			this.$get('member/billAddress/list', {}).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					this.dataList = res.data
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
				}
			})
		},
		edittaitou(id) {
			this.$router.push({
				path: '/orderApplyFapiao',
				query: {
					orderId: this.$route.query.orderId,
					status: this.$route.query.status,
					fapiaoid: id,
				}
			})
		},
		changeDefault(item) {
			item.isDefault = 1
			let self = this
			this.$post('member/billAddress/update/' + item.id, item).then((res) => {
				console.log(res)
				if (res.code === this.GLOBAL.SUCCESS) {
					self.$toast(res.message);
					self.$get('member/billAddress/list', {}).then((res) => {
						console.log(res)
						this.dataList = res.data
					})
				} else {
					this.$dialog.alert({
						theme: 'round-button',
						message: res.message,
						confirmButtonColor: '#00754A'
					})
					item.isDefault = 0
				}
			})

		},
		deletetaitou(id) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '确定删除该条记录吗？',
				contentTips: '',
				btnCancelText: '暂不删除',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					this.$get('member/billAddress/delete/' + id, {}).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast('删除成功');
							self.getList()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		},
		useFapiao(id) {
			let self = this
			self.dialogForm = {
				show: true,
				title: '提示',
				contentText: '使用该条记录吗？',
				contentTips: '',
				btnCancelText: '暂不使用',
				btnConfirmText: '确认',
				cancelCallback: () => {
					this.dialogForm.show = false
				},
				confirmCallback: () => {
					this.dialogForm.show = false
					let form = {
						billAddressId: id,
						billCategory: 1,
						orderId: this.$route.query.orderId,
					}

					let url = ''
					if (this.$route.query.actType === 'edit') {
						url = 'order/openInvApplyUpdate/' + this.$route.query.orderId
					} else {
						url = 'order/openInvApply/' + this.$route.query.orderId
					}
					this.$get(url, form).then((res) => {
						console.log(res)
						if (res.code === this.GLOBAL.SUCCESS) {
							self.$toast(res.message);
							self.onClickLeft()
						} else {
							this.$dialog.alert({
								theme: 'round-button',
								message: res.message,
								confirmButtonColor: '#00754A'
							})
						}
					})
				}
			}
		}
	},
}
</script>
<style scoped lang="less">
.fp-list-page {
	box-sizing: border-box;
	background: #F7F7F7;
	min-height: 100vh;
	padding: 10px 0 50px;

	.no-more {
		margin: 140px auto 0;
		display: flex;
		flex-direction: column;
		flex-wrap: nowrap;
		align-content: center;
		justify-content: center;
		align-items: center;

		.img {
			width: 110px;
			height: 100px;
		}

		.tips {
			margin-top: 8px;
			height: 14px;
			font-size: 12px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #999999;
			line-height: 14px;
		}
	}

	.tt-list {
		padding-bottom: 30px;
		overflow: auto;

		.tt-list-item {
			box-sizing: border-box;
			margin: 12px auto;
			width: 345px;
			height: 98px;
			background: #fff;
			border-radius: 10px;
			position: relative;

			.tt-name-tag {
				position: absolute;
				top: 12px;
				left: 12px;

				.tt-name {
					margin-right: 10px;
					height: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
					line-height: 16px;
				}

				.tt-tag {
					width: 30px;
					height: 16px;
					background: rgba(0, 117, 74, 0.06);
					border-radius: 4px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #00754A;
					line-height: 16px;
					text-align: center;
				}

			}

			.tt-cont {
				position: absolute;
				top: 34px;
				left: 12px;
				width: 270px;
				height: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 11px;
				color: #333333;
				line-height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.tt-line {
				position: absolute;
				top: 58px;
				left: 12px;
				width: 323px;
				height: 1px;
				background-color: #EEEEEE;
			}

			.tt-btn {
				width: 48px;
				height: 26px;
				background: #00754A;
				border-radius: 6px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 12px;
				color: #FFFFFF;
				line-height: 26px;
				text-align: center;
				position: absolute;
				top: 16px;
				right: 12px;
			}

			.tt-d {
				display: flex;
				flex-direction: row;
				flex-wrap: nowrap;
				align-content: center;
				justify-content: center;
				align-items: center;
				position: absolute;
				bottom: 12px;
				left: 12px;

				.tt-d-icon {
					width: 16px;
					height: 16px;
				}

				.tt-d-text {
					margin-left: 8px;
					height: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 11px;
					color: #666666;
					line-height: 14px;
				}
			}

			.tt-icon-edit {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 40px;
			}

			.tt-icon-del {
				width: 16px;
				height: 16px;
				position: absolute;
				bottom: 12px;
				right: 12px;
			}

		}


	}


	.btn-box {
		position: fixed;
		left: 0;
		bottom: 0;
		width: 375px;
		height: 49px;
		background: #FFFFFF;
		padding: 5px 0 0;

		.btn {
			margin: 0 auto;
			width: 355px;
			height: 40px;
			background: #00754A;
			border-radius: 10px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			font-size: 15px;
			color: #FFFFFF;
			line-height: 40px;
			text-align: center;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/order/orderFapiaoList.vue